<ion-button (click)="presentConfirmation()" color="danger">Logout</ion-button>
